import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { ThumbApplicationFromType } from '../service-proxies';


export class Admin_Dashboard_Daily_Attendance implements IAdmin_Dashboard_Daily_Attendance {
    employee!: EmployeeSummaryDto;
    dayFlag!: string | undefined;
    workFromHomeFlag!: string | undefined;
    workFromHomeReason!: string | undefined;
    thumbInTime!: Date | undefined;
    thumbOutTime!: Date | undefined;
    profileImageUrl!: string | undefined;
    designation!: string | undefined;
    departmentName!: string | undefined;
    locationName!: string | undefined;
    company!: CompanyDto;
    project!: ProjectDto;
    thumbApplicationFromType!: ThumbApplicationFromType;
    thumbApplicationFromTypeName!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Attendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.dayFlag = _data["dayFlag"];
            this.workFromHomeFlag = _data["workFromHomeFlag"];
            this.workFromHomeReason = _data["workFromHomeReason"];
            this.thumbInTime = _data["thumbInTime"] ? new Date(_data["thumbInTime"].toString()) : <any>undefined;
            this.thumbOutTime = _data["thumbOutTime"] ? new Date(_data["thumbOutTime"].toString()) : <any>undefined;
            this.profileImageUrl = _data["profileImageUrl"];
            this.designation = _data["designation"];
            this.departmentName = _data["departmentName"];
            this.locationName = _data["locationName"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.thumbApplicationFromType = _data["thumbApplicationFromType"];
            this.thumbApplicationFromTypeName = _data["thumbApplicationFromTypeName"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Attendance {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Attendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["dayFlag"] = this.dayFlag;
        data["workFromHomeFlag"] = this.workFromHomeFlag;
        data["workFromHomeReason"] = this.workFromHomeReason;
        data["thumbInTime"] = this.thumbInTime ? this.thumbInTime.toISOString() : <any>undefined;
        data["thumbOutTime"] = this.thumbOutTime ? this.thumbOutTime.toISOString() : <any>undefined;
        data["profileImageUrl"] = this.profileImageUrl;
        data["designation"] = this.designation;
        data["departmentName"] = this.departmentName;
        data["locationName"] = this.locationName;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["thumbApplicationFromType"] = this.thumbApplicationFromType;
        data["thumbApplicationFromTypeName"] = this.thumbApplicationFromTypeName;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Attendance {
    employee: EmployeeSummaryDto;
    dayFlag: string | undefined;
    workFromHomeFlag: string | undefined;
    workFromHomeReason: string | undefined;
    thumbInTime: Date | undefined;
    thumbOutTime: Date | undefined;
    profileImageUrl: string | undefined;
    designation: string | undefined;
    departmentName: string | undefined;
    locationName: string | undefined;
    company: CompanyDto;
    project: ProjectDto;
    thumbApplicationFromType: ThumbApplicationFromType;
    thumbApplicationFromTypeName: string | undefined;
}

